<template>
    <div class="cabinet-content-wrap">
        <header
            id="supplier-cabinet-header-d"
            class="cabinet-header flex flex-align-center"
        >
            <h1 class="h1 cabinet-title">Настройки аккаунта</h1>
        </header>

        <header
            id="supplier-cabinet-header-m"
            class="cabinet-header flex flex-align-center hide"
        >
            <a
                id="supplier-cabinet-back"
                href="javascript:void(0)"
                class="cabinet-btn--form-back-header-edit"
            ></a>
            <h1 id="supplier-cabinet-title" class="h1 cabinet-title"></h1>
        </header>

        <header
            id="supplier-cabinet-header-brands-m"
            class="cabinet-header flex flex-align-center hide"
        >
            <a
                id="supplier-cabinet-back-brands"
                href="javascript:void(0)"
                class="cabinet-btn--form-back-header-edit"
                @click="SET_ACTIVE_BRAND(-1)"
            ></a>
            <h1 id="supplier-cabinet-title-brands" class="h1 cabinet-title">
                {{ getActiveBrand ? getActiveBrand.BrandName : 'Новый бренд' }}
            </h1>
        </header>

        <section
            class="supplier-nav supplier-nav--settings flex flex-align-center"
        >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link active"
                data-target="personal-data"
                @click.prevent="setActiveTab('personal')"
                >Личные данные</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="brands"
                @click.prevent="setActiveTab('brands')"
                >Бренды</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="access"
                @click.prevent="setActiveTab('access')"
                >Управление доступом</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="password"
                @click.prevent="setActiveTab('password')"
                >Пароль</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="docs"
                @click.prevent="setActiveTab('docs')"
                >Документы</a
            >
            <!-- <a href="javascript:void(0)" class="supplier-nav__link" data-target="close-profile">Закрыть аккаунт</a> -->
        </section>

        <supplier-personal-data />

        <supplier-password />

        <supplier-brands :key="tabTimeStamp" />

        <supplier-access-control />

        <supplier-docs />

        <form
            id="close-profile"
            action=""
            class="cabinet-settings supplier-tab hide"
            data-title="Закрыть аккаунт"
        >
            <div class="supplier-settings__info">
                Если вы закроете ваш аккаунт, доступ в ваш личный кабинет будет
                закрыт. Вы можете возобновить работу в любой момент. Для этого
                напишите нам на
                <a href="mailto:pvv@russianjeweller.ru" class="cabinet-link"
                    >pvv@russianjeweller.ru</a
                >
            </div>

            <div class="cabinet-btn__wrap--mt">
                <button type="button" class="cabinet-btn cabinet-btn--gray">
                    Закрыть аккаунт
                </button>
            </div>
        </form>
    </div>
    <!-- /cabinet-content-wrap -->
</template>

<script>
import SupplierPersonalData from '@/components/Cabinet/Supplier/Settings/PersonalData'
import SupplierPassword from '@/components/Cabinet/Supplier/Settings/Password'
import SupplierBrands from '@/components/Cabinet/Supplier/Settings/Brands'
import SupplierAccessControl from '@/components/Cabinet/Supplier/Settings/AccessControl'
import SupplierDocs from '@/components/Cabinet/Supplier/Settings/Docs'

import supplierNav from '@/mixins/supplier-nav'

import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'SupplierSettings',
    components: {
        SupplierPersonalData,
        SupplierPassword,
        SupplierBrands,
        SupplierAccessControl,
        SupplierDocs
    },
    mixins: [supplierNav],
    data() {
        return {
            tabTimeStamp: '' //для ресета валидации полей бренда
        }
    },
    computed: {
        ...mapGetters('supplierBrand', ['getActiveBrand'])
    },
    mounted() {
        this.$nextTick(() => {
            this.supplierNav()
        })
    },
    methods: {
        ...mapMutations('supplierBrand', ['SET_ACTIVE_BRAND']),
        setActiveTab(tab) {
            if (tab == 'brands') {
                this.tabTimeStamp = '' + Date.now()
            }
        }
    }
}
</script>
